import React, {useEffect, useState} from 'react';
import {Button, Card, Form, Input, message, Modal, Upload, UploadFile, UploadProps} from "antd";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import ImgCrop from "antd-img-crop";


const Project_downloadmanagement=()=>{

    document.title='版本控制';

    let data_time=dayjs().unix();

    const navigate = useNavigate();
    const [data_sub_add_send_image_image_info, setdata_sub_add_send_image_image_info] = useState([{uid: '', name: '', status: '', response: '', url: ''}])



    useEffect(() => {


        setfetch_soft_info_select_log({message: 'click', value: '', time: data_time})

    }, []);

    const [add_soft_ver_modal_open, setadd_soft_ver_modal_open] = useState(false)

    const [add_soft_ver_select_info, setadd_soft_ver_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [add_soft_ver_select_log, setadd_soft_ver_select_log] = useState({message: '', value: '', time: 0})
    const add_soft_ver = (e1: any) => {

        setadd_soft_ver_select_log({message: 'click', value: '', time: data_time})

        setadd_soft_ver_modal_open(true);

        setadd_soft_ver_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setadd_soft_ver_modal_oncancel = () => {

        setadd_soft_ver_modal_open(false);
    }


    const [add_soft_ver_modal_form]=Form.useForm();

    const add_soft_ver_modal_initialValues={




    }

    const [add_soft_ver_modal_onfinish_select_log,setadd_soft_ver_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [add_soft_ver_modal_onfinish_select_info,setadd_soft_ver_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const add_soft_ver_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setadd_soft_ver_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setadd_soft_ver_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_add_soft_ver,setreturn_data_add_soft_ver]=useState({});

    const add_soft_ver_body = new FormData();


    add_soft_ver_body.append('finish_data', JSON.stringify(add_soft_ver_modal_onfinish_select_info.value1));

    add_soft_ver_body.append('userToken', String(Cookies.get('userToken_chattool')));
    add_soft_ver_body.append('file_info_json', JSON.stringify(data_sub_add_send_image_image_info))

    add_soft_ver_body.append('time', String(add_soft_ver_modal_onfinish_select_info.time));

    add_soft_ver_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/soft_info/insert/insert_soft_info.php', {


                method: 'POST',
                body: add_soft_ver_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setadd_soft_ver_modal_open(false)

                    setreturn_data_add_soft_ver(return_data);

                      setfetch_soft_info_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(add_soft_ver_modal_onfinish_select_log.message!==''){

            data_async();
            setadd_soft_ver_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [add_soft_ver_modal_onfinish_select_log]);






    const [fetch_soft_info_select_info, setfetch_soft_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_soft_info_select_log, setfetch_soft_info_select_log] = useState({message: '', value: '', time: 0})
    const fetch_soft_info = (e1: any) => {

        setfetch_soft_info_select_log({message: 'click', value: '', time: data_time})



        setfetch_soft_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_soft_info,setreturn_data_fetch_soft_info]=useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "8",
                "uuid": "ad46a853-2f24-415f-8283-74c8e4967046",
                "soft_name": "21",
                "soft_ver": "66",
                "soft_ver_update_info": "66",
                "soft_file_patch": "https://chatv2.leytcn.com/api/soft_file/1734002482_12.rar",
                "file_info_json": "[{\"uid\":\"rc-upload-1734002286636-19\",\"status\":\"done\",\"name\":\"12.rar\",\"response\":{\"name\":\"1734002482_12.rar\",\"status\":\"done\",\"url\":\"https://chatv2.leytcn.com/api/soft_file/1734002482_12.rar\",\"file_type\":\"application/octet-stream\"},\"url\":\"https://chatv2.leytcn.com/api/soft_file/1734002482_12.rar\"}]",
                "created": 0,
                "status": "en",
                "is_show": '0'
            }
        ]
    });

    const fetch_soft_info_body = new FormData();


    fetch_soft_info_body.append('id', fetch_soft_info_select_info.value1);

    fetch_soft_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_soft_info_body.append('time', String(fetch_soft_info_select_info.time));

    fetch_soft_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/soft_info/fetch/fetch_info.php', {


                method: 'POST',
                body: fetch_soft_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

//获取消息，无需提示
                 /*   message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_soft_info(return_data);

               //     setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_soft_info_select_log.message!==''){

            data_async();
            setfetch_soft_info_select_log({message:'',value:'',time:0})
        }
    }, [fetch_soft_info_select_log]);





    const [fileList_add_send_image_image_info, setFileList_add_send_image_image_info] = useState<UploadFile[]>([]);


    const onChange_add_send_image_image_info: UploadProps['onChange'] = ({fileList: newFileList}) => {
        setFileList_add_send_image_image_info(newFileList);


        console.log({data: newFileList})


        const allDone = newFileList.every(file => file.status === 'done');

        if (allDone) {
            console.log('All files are uploaded successfully:', newFileList);
            let data_time = dayjs().unix();


            setdata_sub_add_send_image_image_info([]);
            newFileList.map(item => {


                console.log('Upload completed:', {type: 'image', info: item.response.url});

                const data_jj = [{type: 'image', value: item.response.url}]

                setdata_sub_add_send_image_image_info(prevDataValue => [
                    ...prevDataValue,
                    {uid: item.uid, status: 'done', name: item.name, response: item.response, url: item.response.url}
                ])

            })


            //    setget_data({ message:'1',value:'',time:data_time});
        }


        console.log('Updated file list:', {value: newFileList});


    };



    const download_file=(file_url:any)=>{


        window.location.href=file_url
    }




    const [software_del_modal_open, setsoftware_del_modal_open] = useState(false)

    const [software_del_select_info, setsoftware_del_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [software_del_select_log, setsoftware_del_select_log] = useState({message: '', value: '', time: 0})
    const software_del = (e1: any,name:any) => {

        setsoftware_del_select_log({message: 'click', value: '', time: data_time})

        setsoftware_del_modal_open(true);

        setsoftware_del_select_info({value1: e1, value2:name, value3: '', time: data_time})
    }


    const setsoftware_del_modal_oncancel = () => {

        setsoftware_del_modal_open(false);
    }


    const [software_del_modal_next_button_select_log,setsoftware_del_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const software_del_modal_next_button = () => {

        let data_time=dayjs().unix();

        setsoftware_del_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_software_del,setreturn_data_software_del]=useState({});

    const software_del_body = new FormData();


    software_del_body.append('uuid', software_del_select_info.value1);


    software_del_body.append('soft_name', software_del_select_info.value2);


    software_del_body.append('userToken', String(Cookies.get('userToken_chattool')));

    software_del_body.append('time', String(software_del_modal_next_button_select_log.time));

    software_del_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/soft_info/delete/delete_software.php', {


                method: 'POST',
                body: software_del_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setsoftware_del_modal_open(false)

                    setreturn_data_software_del(return_data);
                    setfetch_soft_info_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(software_del_modal_next_button_select_log.message!==''){

            data_async();
            setsoftware_del_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [software_del_modal_next_button_select_log]);





    const [set_show_software_modal_open, setset_show_software_modal_open] = useState(false)

    const [set_show_software_select_info, setset_show_software_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [set_show_software_select_log, setset_show_software_select_log] = useState({message: '', value: '', time: 0})
    const set_show_software = (e1: any,name:any) => {

        setset_show_software_select_log({message: 'click', value: '', time: data_time})

        setset_show_software_modal_open(true);

        setset_show_software_select_info({value1: e1, value2: name, value3: '', time: data_time})
    }


    const setset_show_software_modal_oncancel = () => {

        setset_show_software_modal_open(false);
    }


    const [set_show_software_modal_next_button_select_log,setset_show_software_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const set_show_software_modal_next_button = () => {

        let data_time=dayjs().unix();

        setset_show_software_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_set_show_software,setreturn_data_set_show_software]=useState({});

    const set_show_software_body = new FormData();


    set_show_software_body.append('uuid', set_show_software_select_info.value1);
    set_show_software_body.append('soft_name', set_show_software_select_info.value2);

    set_show_software_body.append('userToken', String(Cookies.get('userToken_chattool')));

    set_show_software_body.append('time', String(set_show_software_modal_next_button_select_log.time));

    set_show_software_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/soft_info/update/set_show_software.php', {


                method: 'POST',
                body: set_show_software_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setset_show_software_modal_open(false)

                    setreturn_data_set_show_software(return_data);
                    setfetch_soft_info_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(set_show_software_modal_next_button_select_log.message!==''){

            data_async();
            setset_show_software_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [set_show_software_modal_next_button_select_log]);





    return(
        <div>

            <Button onClick={add_soft_ver}>添加版本</Button>



            {return_data_fetch_soft_info.message!==2000?<div></div>:<div>{
                return_data_fetch_soft_info.info.map(item1=>(<div>

                    <Card>

                        <div style={{display:'flex'}}>

                            <div style={{flexGrow:1}}>

                                <label>软件名：{item1.soft_name}</label>
                                <p></p>
                                <label>版本号：{item1.soft_ver}</label>
                                <p></p>
                                <label>发布时间：{dayjs.unix(item1.created).format('YYYY-MM-DD HH:mm:ss') }</label>
                            </div>



                            <div>
                                <a href={item1.soft_file_patch} >下载</a>

                                <p></p>
                                <a onClick={()=>software_del(item1.uuid,item1.soft_name)}>删除</a>

                                <p></p>

                                {item1.is_show==='1'?<div></div>:<div>          <a onClick={()=>set_show_software(item1.uuid,item1.soft_name)}>推荐</a>
                                </div>}
                             </div>
                        </div>



                    </Card>

                </div>))
            }</div>}







            <Modal open={set_show_software_modal_open} onCancel={setset_show_software_modal_oncancel} footer={null} title={'是否设置为外部下载'}>


                <Button onClick={set_show_software_modal_next_button}>

                    设置
                </Button>


                <Button style={{marginLeft:10}} onClick={setset_show_software_modal_oncancel}>

                    取消
                </Button>


            </Modal>




            <Modal open={software_del_modal_open} onCancel={setsoftware_del_modal_oncancel} footer={null} title={'标题内容'}>


                <Button onClick={software_del_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft:10}} onClick={setsoftware_del_modal_oncancel}>

                    取消
                </Button>


            </Modal>




            <Modal open={add_soft_ver_modal_open} onCancel={setadd_soft_ver_modal_oncancel} footer={null} title={'发布版本'}>




                <Form form={add_soft_ver_modal_form} initialValues={add_soft_ver_modal_initialValues} onFinish={add_soft_ver_modal_onfinish}>

                    <label>软件名</label>

                    <Form.Item name={'soft_name'} rules={[{message:'必填项',required:true}]}>

                        <Input>



                        </Input>


                    </Form.Item>

                    <label>软件版本号</label>

                    <Form.Item name={'soft_ver'} rules={[{message:'必填项',required:true}]}>

                        <Input>



                        </Input>


                    </Form.Item>

                    <label>版本信息</label>

                    <Form.Item name={'soft_ver_update_info'} rules={[{message:'必填项',required:true}]}>

                        <Input.TextArea>



                        </Input.TextArea>


                    </Form.Item>

                    <label>文件路径</label>

                    <Form.Item name={'soft_file_patch'} >


                        <Input>


                        </Input>

                          {/*  <Upload
                                action="https://chatv2.leytcn.com/api/upload_file.php"
                                listType="picture-card"
                                fileList={fileList_add_send_image_image_info}
                                onChange={onChange_add_send_image_image_info}

                            >
                                {fileList_add_send_image_image_info.length < 1 && '+ Upload'}
                            </Upload>*/}


                    </Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={setadd_soft_ver_modal_oncancel}>取消</Button>

                </Form>


            </Modal>




        </div>
    )
}


export default Project_downloadmanagement;
